export default __webpack_public_path__ + "static/media/pieChartDshTab.4d614cbd.svg";